var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadanalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.05 27.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1f2f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Load analysis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-237.64,248.44h-34a1.54,1.54,0,0,0-1.54,1.54,1.54,1.54,0,0,0,1.54,1.54h3.86v1.6a1.54,1.54,0,0,0,1.54,1.54,1.54,1.54,0,0,0,1.54-1.54v-1.6h20.08v1.6a1.54,1.54,0,0,0,1.54,1.54,1.54,1.54,0,0,0,1.54-1.54v-1.6h3.86a1.54,1.54,0,0,0,1.54-1.54,1.52,1.52,0,0,0-1.53-1.54h0Zm0,0",
    transform: "translate(273.16 -226.95)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 6.67,
    width: 3.09,
    height: 20.07,
    rx: 0.99,
    ry: 0.99
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 11.88,
    y: 5.61,
    width: 3.09,
    height: 14.46,
    rx: 0.99,
    ry: 0.99
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 17.08,
    y: 2.36,
    width: 3.09,
    height: 17.71,
    rx: 0.99,
    ry: 0.99
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 22.28,
    width: 3.09,
    height: 20.07,
    rx: 0.99,
    ry: 0.99
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 27.6,
    y: 9.11,
    width: 3.09,
    height: 10.96,
    rx: 0.99,
    ry: 0.99
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadanalysis);
export default __webpack_public_path__ + "static/media/Load analysis.a2ae2315.svg";
export { ForwardRef as ReactComponent };